import apiService from './apiService';

async function request(promise) {
  const res = await promise;
  if (!res.success) {
    throw new Error(res.message || 'Erreur API');
  }
  return res;
}

const mcpDomainsService = {
  async getAdminMatrix() {
    const res = await request(apiService.get('/admin/mcp-domains'));
    return res.data ?? {};
  },

  async saveAdminMatrix(matrix) {
    const res = await request(apiService.put('/admin/mcp-domains', { matrix }));
    return res.data ?? {};
  },
};

export default mcpDomainsService;
